import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { ShieldCheck, Lock, Fingerprint } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export default function AuthShell({ title, subtitle, children, footer }) {
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  return (
    <div className="min-h-screen bg-navy grid lg:grid-cols-2">
      {/* Brand panel */}
      <div className="relative hidden lg:flex flex-col justify-between p-12 rc-ambient border-r border-white/10 overflow-hidden">
        <div className="absolute inset-0 rc-grid-lines opacity-40" />
        <div className="relative">
          <Logo />
        </div>
        <div className="relative max-w-md">
          <h2 className="font-heading text-3xl font-light text-white leading-tight">
            {L("Accesso riservato all'area clienti e operatori", "Reserved access to the client and operator area", "Geschützter Zugang zum Kunden- und Betreiberbereich")}
          </h2>
          <p className="mt-4 text-slate-400">
            {L("Gestisci le tue pratiche di recupero in un ambiente sicuro, non-custodial e documentato.", "Manage your recovery cases in a secure, non-custodial and documented environment.", "Verwalten Sie Ihre Wiederherstellungsfälle in einer sicheren, non-custodial und dokumentierten Umgebung.")}
          </p>
          <div className="mt-8 space-y-3">
            {[
              { icon: ShieldCheck, t: L("Processo non-custodial verificato", "Verified non-custodial process", "Verifizierter Non-custodial-Prozess") },
              { icon: Lock, t: L("Accesso controllato ai documenti", "Controlled document access", "Kontrollierter Dokumentenzugriff") },
              { icon: Fingerprint, t: L("Verifica di identità e titolarità", "Identity and ownership verification", "Identitäts- und Eigentumsprüfung") },
            ].map((x, i) => (
              <div key={i} className="flex items-center gap-3 text-sm text-slate-300">
                <x.icon className="h-5 w-5 text-cyanx" />{x.t}
              </div>
            ))}
          </div>
        </div>
        <p className="relative text-xs text-slate-600">© {new Date().getFullYear()} Recovers Crypto</p>
      </div>

      {/* Form panel */}
      <div className="flex flex-col justify-center px-6 sm:px-12 py-12">
        <div className="w-full max-w-md mx-auto">
          <div className="lg:hidden mb-8"><Logo /></div>
          <h1 className="font-heading text-3xl font-medium text-white">{title}</h1>
          {subtitle && <p className="mt-2 text-slate-400">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-slate-400">{footer}</div>}
          <p className="mt-8 text-xs text-slate-600">
            <Link to="/" className="hover:text-slate-400">← {L("Torna al sito", "Back to site", "Zurück zur Website")}</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
